import { TLink } from "@/components/molecules/Button";
import { faTurnDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const anchors = [
  { title: "Contracted Development", href: "#contracted_development" },
  { title: "Solution Profile", href: "#solution" },
  { title: "WEB Development Map", href: "#web_development" },
  { title: "Consulting", href: "#consulting" },
  { title: "Package", href: "#package" },
];

export const ServiceNav = () => {
  return (
    <>
      <div className="bg-white px-6 pt-4 sm:px-8 md:px-12 md:pt-4 lg:pt-6">
        <ul className="mx-auto mb-4 flex max-w-7xl flex-wrap justify-center gap-2 fluid-text-[12px,16px] md:mb-0 md:justify-end md:gap-6">
          {anchors.map((anchor) => (
            <li key={anchor.index}>
              <TLink
                href={anchor.href}
                variant="mono"
                color="p"
                className="group"
              >
                {anchor.title}
                <FontAwesomeIcon
                  icon={faTurnDown}
                  className="ml-2 text-icn group-hover:text-hov"
                />
              </TLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
